import React from "react";


const cardData = [
  {
    // icon: <FaHospital />,
    title: "Find & Compare Hospitals",
    description:
      "Find extensive information on hospitals & doctors that can treat you. Compare prices, reviews, qualifications & facilities.",
    iconSrc: 'assets/imgs/china/navy_Find and Compare Hospitals.png',
  },
  {
    // icon: <FaDollarSign />,
    title: "Get free Expert Opinion",
    description:
      "Use our inquiry forms to contact providers of interest. Receive an expert medical opinion and treatment cost estimate.",
    iconSrc: 'assets/imgs/china/navy_Get Free Expert Opinion.png',
  },
  {
    // icon: <FaUserMd />,
    title: "Expert Medical Professionals",
    description:
      "Connect with internationally trained doctors and specialists in various medical fields.",
    iconSrc: 'assets/imgs/china/navy_Expert Medical Professionals.png',
  },
  {
    // icon: <FaClock />,
    title: "Select Provider",
    description:
      "Finalize the right provider for your treatment. Make an informed decision.",
    iconSrc: 'assets/imgs/china/navy_Select Provider.png'
  },
  {
    // icon: <FaGlobe />,
    title: "Plan Your Trip",
    description:
      "Once you decide, our hospital coordinators will help to schedule appointments, accommodation and all other logistics.",
    iconSrc: 'assets/imgs/china/navy_Plan Your Trip.png',
  },
  {
    // icon: <FaBriefcaseMedical />,
    title: "Return Home Fit",
    description:
      "Get cured, pay hospital after treatment and return home safe. Our care team is available throughout your journey to good health!",
    iconSrc: 'assets/imgs/china/navy_Return Home Fit.png',
  },

];



const AsSimpleAsCard = () => {
  return (
    <div
      className="container py-5"
      style={{
        background: "linear-gradient(to bottom right, #ffffffff, #ffffffff)",
        borderRadius: "18px",
      }}
    >
      <div className="row g-4">
        {cardData.map((card, index) => (
          <div className="col-12 col-sm-6 col-lg-4" key={index}>
            <div
              className="service-item-2 fade-top card h-100 rounded-4 text-center p-3 border-1 border-gray-200 transition-all duration-300 hover:-translate-y-2"
              style={{
                background:
                  "linear-gradient(180deg, #E2EEFF 0%, rgba(255, 255, 255, 0) 50%)",
              }}
            >
              <div
                className="icon mx-auto mb-3 d-flex align-items-center justify-content-center "
                style={{
                  backgroundColor: "#fff",
                  borderRadius: "50%",
                  width: "70px",
                  height: "70px",


                }}
              >
                {card.icon ? (
                  card.icon
                ) : (
                  <img
                    src={card.iconSrc}
                    alt="icon"
                    style={{ width: "55px", height: "55px",  }}
                  />
                  

                )}
              </div>
              <div className="card-body px-2 content">
                <h5 className="card-title fw-semibold title">
                  <a
                    href={card.link || "#"}
                    style={{ textDecoration: "none", color: "inherit" }}
                  >
                    {card.title}
                  </a>
                </h5>
                <p className="card-text text-muted small">{card.description}</p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default AsSimpleAsCard;



